import React from 'react';
import { Link } from "react-router-dom";
import { Card, Row, Col, Input, Button, Table, Modal,
    message, Alert, Typography, Tag, Divider, Space, Tooltip,
} from 'antd';
import {
    SearchOutlined, PlusOutlined, FormOutlined, CloseSquareOutlined,
    ExclamationCircleOutlined, RedoOutlined, SettingOutlined,
    CalendarOutlined, CheckCircleFilled, CloseCircleFilled,
    PercentageOutlined, UndoOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from "../../store/actions";
import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
    title: 'Data Diskon',
    apiUrl: { data: 'master/api/discount/' },
    pageUrl: { form: '/admin/pengaturan/diskon/form/' },
    breadCrumb: [
        <span><SettingOutlined /> Pengaturan</span>,
        'Diskon'
    ]
};

const config = new Config();

const PERSEN_GROUPS = [
    { key: 'bbnkb_i',         label: 'BBNKB I',           pokok: 'pokok_bbnkb_i',         denda: 'denda_bbnkb_i',         color: '#1890ff' },
    { key: 'pkb',              label: 'PKB Berjalan',       pokok: 'pokok_pkb',              denda: 'denda_pkb',              color: '#52c41a' },
    { key: 'pkb_tunggak',      label: 'PKB Tunggak',        pokok: 'tunggakan_pokok_pkb',    denda: 'tunggakan_denda_pkb',    color: '#fa8c16' },
    { key: 'swdkllj',          label: 'SWDKLLJ Berjalan',   pokok: 'pokok_swdkllj',          denda: 'denda_swdkllj',          color: '#13c2c2' },
    { key: 'swdkllj_tunggak',  label: 'SWDKLLJ Tunggak',    pokok: 'tunggakan_pokok_swdkllj', denda: 'tunggakan_denda_swdkllj', color: '#eb2f96' },
];

const KONDISI_FIELDS = [
    { name: 'progressif',  label: 'Progressif',  color: '#722ed1' },
    { name: 'plat_merah',  label: 'Plat Merah',  color: '#f5222d' },
    { name: 'plat_putih',  label: 'Plat Putih',  color: '#595959' },
    { name: 'plat_kuning', label: 'Plat Kuning', color: '#faad14' },
];

const pct = (val) => parseFloat(val || 0).toFixed(2) + '%';

class DataDiskon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errMsg: '',
            loadingData: false,
            loadingButton: false,
            pagination: { pageSize: 25 },
            searchText: '',
            dataSource: [],
            isMobile: window.innerWidth <= 768,
        };
    }

    UNSAFE_componentWillMount() { this.props.initHandler(); }

    componentDidMount() {
        this.getData();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= 768 });
    };

    showRestoreConfirm(id) {
        Modal.confirm({
            title: 'Aktifkan Diskon',
            icon: <UndoOutlined style={{ color: '#52c41a' }} />,
            content: 'Data diskon akan diaktifkan kembali.',
            okText: 'Aktifkan',
            okButtonProps: { style: { background: '#52c41a', borderColor: '#52c41a' } },
            cancelText: 'Batal',
            onOk: () => this.prosesRestore(id),
        });
    }

    prosesRestore(id) {
        message.loading({ content: 'Mengaktifkan...', key: 'toast' });
        this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
            .then(() => {
                if (this.props.isSuccess) {
                    message.success({ content: 'Data diskon berhasil diaktifkan kembali', duration: 2, key: 'toast' });
                    this.getData();
                } else {
                    message.error({ content: 'Gagal mengaktifkan data', duration: 2, key: 'toast' });
                }
            })
            .catch(() => {
                message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
            });
    }

    showDeleteConfirm(id) {
        Modal.confirm({
            title: 'Nonaktifkan Diskon',
            icon: <ExclamationCircleOutlined />,
            content: 'Data diskon akan dinonaktifkan. Data tetap tersimpan dan dapat diaktifkan kembali.',
            okText: 'Nonaktifkan',
            okType: 'danger',
            cancelText: 'Batal',
            onOk: () => this.prosesHapus(id),
        });
    }

    prosesHapus(id) {
        message.loading({ content: 'Menonaktifkan...', key: 'toast' });
        this.setState({ loadingButton: true });
        this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
            .then(() => {
                this.setState({ loadingButton: false });
                if (this.props.isSuccess) {
                    message.success({ content: 'Data diskon berhasil dinonaktifkan', duration: 2, key: 'toast' });
                    this.getData();
                } else {
                    message.error({ content: 'Gagal menonaktifkan data', duration: 2, key: 'toast' });
                    this.setState({ errMsg: this.props.responseMsg });
                }
            }).catch(() => {
                this.setState({ loadingButton: false });
                message.error({ content: 'Kesalahan jaringan, coba lagi', duration: 2, key: 'toast' });
            });
    }

    async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
        this.setState({ loadingData: true });
        this.props.ajaxViewHandler('get', `${configClass.apiUrl.data}?limit=${limit}&offset=${offset}&search=${search}&include_deleted=true`)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    const pagination = { ...this.state.pagination, total: data.count };
                    this.setState({ dataSource: data.results, pagination });
                } else {
                    this.setState({ errMsg: this.props.responseMsg });
                    message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
                }
                this.setState({ loadingData: false });
            }).catch(() => {
                message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
                this.setState({ loadingData: false });
            });
    }

    handleTableChange = (pagination) => {
        this.setState({ pagination });
        if (pagination.current === 1) {
            this.getData(pagination.pageSize);
        } else {
            this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
        }
    };

    getTableColumns() {
        const pctRender = (val) => (
            <Text style={{ fontSize: 12 }}>{pct(val)}</Text>
        );
        const boolRender = (val) => val
            ? <CheckCircleFilled style={{ color: '#52c41a', fontSize: 14 }} />
            : <CloseCircleFilled style={{ color: '#d9d9d9', fontSize: 14 }} />;

        return [
            {
                title: 'Fungsi',
                dataIndex: 'fungsi_nama',
                key: 'fungsi_nama',
                width: 160,
                fixed: 'left',
                render: (v) => <Text strong style={{ fontSize: 12 }}>{v}</Text>,
            },
            {
                title: 'Berlaku',
                children: [
                    { title: 'Mulai',  dataIndex: 'mulai_dari',     key: 'mulai_dari',     width: 90, align: 'center', render: (v) => <Text style={{ fontSize: 11 }}>{v}</Text> },
                    { title: 'Sampai', dataIndex: 'sampai_dengan',  key: 'sampai_dengan',  width: 90, align: 'center', render: (v) => <Text style={{ fontSize: 11 }}>{v}</Text> },
                ],
            },
            {
                title: <Text style={{ color: '#1890ff', fontWeight: 600 }}>BBNKB I</Text>,
                children: [
                    { title: 'Pokok', dataIndex: 'pokok_bbnkb_i', key: 'pokok_bbnkb_i', width: 72, align: 'center', render: pctRender },
                    { title: 'Denda', dataIndex: 'denda_bbnkb_i', key: 'denda_bbnkb_i', width: 72, align: 'center', render: pctRender },
                ],
            },
            {
                title: <Text style={{ color: '#52c41a', fontWeight: 600 }}>PKB Berjalan</Text>,
                children: [
                    { title: 'Pokok', dataIndex: 'pokok_pkb', key: 'pokok_pkb', width: 72, align: 'center', render: pctRender },
                    { title: 'Denda', dataIndex: 'denda_pkb', key: 'denda_pkb', width: 72, align: 'center', render: pctRender },
                ],
            },
            {
                title: <Text style={{ color: '#fa8c16', fontWeight: 600 }}>PKB Tunggak</Text>,
                children: [
                    { title: 'Pokok', dataIndex: 'tunggakan_pokok_pkb',  key: 'tunggakan_pokok_pkb',  width: 72, align: 'center', render: pctRender },
                    { title: 'Denda', dataIndex: 'tunggakan_denda_pkb',  key: 'tunggakan_denda_pkb',  width: 72, align: 'center', render: pctRender },
                ],
            },
            {
                title: <Text style={{ color: '#13c2c2', fontWeight: 600 }}>SWDKLLJ Berjalan</Text>,
                children: [
                    { title: 'Pokok', dataIndex: 'pokok_swdkllj', key: 'pokok_swdkllj', width: 72, align: 'center', render: pctRender },
                    { title: 'Denda', dataIndex: 'denda_swdkllj', key: 'denda_swdkllj', width: 72, align: 'center', render: pctRender },
                ],
            },
            {
                title: <Text style={{ color: '#eb2f96', fontWeight: 600 }}>SWDKLLJ Tunggak</Text>,
                children: [
                    { title: 'Pokok', dataIndex: 'tunggakan_pokok_swdkllj', key: 'tunggakan_pokok_swdkllj', width: 72, align: 'center', render: pctRender },
                    { title: 'Denda', dataIndex: 'tunggakan_denda_swdkllj', key: 'tunggakan_denda_swdkllj', width: 72, align: 'center', render: pctRender },
                ],
            },
            {
                title: 'Kondisi',
                children: [
                    { title: 'Prog',   dataIndex: 'progressif',  key: 'progressif',  width: 52, align: 'center', render: boolRender },
                    { title: 'Merah',  dataIndex: 'plat_merah',  key: 'plat_merah',  width: 58, align: 'center', render: boolRender },
                    { title: 'Putih',  dataIndex: 'plat_putih',  key: 'plat_putih',  width: 58, align: 'center', render: boolRender },
                    { title: 'Kuning', dataIndex: 'plat_kuning', key: 'plat_kuning', width: 62, align: 'center', render: boolRender },
                ],
            },
            {
                title: 'Status',
                dataIndex: 'deleted_at',
                key: 'status',
                width: 110,
                align: 'center',
                render: (val) => val
                    ? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Tidak Aktif</Tag>
                    : <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag>,
            },
            {
                title: 'Aksi',
                key: 'aksi',
                width: 80,
                fixed: 'right',
                align: 'center',
                render: (_, row) => (
                    <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                        <Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
                            {row.deleted_at ? (
                                <Button size="small" shape="circle" type="primary" ghost disabled><FormOutlined /></Button>
                            ) : (
                                <Link to={configClass.pageUrl.form + row.id}>
                                    <Button size="small" shape="circle" type="primary" ghost><FormOutlined /></Button>
                                </Link>
                            )}
                        </Tooltip>
                        {!row.deleted_at ? (
                            <Tooltip title="Nonaktifkan">
                                <Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}><CloseSquareOutlined /></Button>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Aktifkan kembali">
                                <Button size="small" shape="circle"
                                    style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
                                    onClick={() => this.showRestoreConfirm(row.id)}
                                >
                                    <UndoOutlined />
                                </Button>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
        ];
    }

    renderMobileCard(record) {
        return (
            <Card
                key={record.id}
                style={{ marginBottom: 10, borderRadius: 10, border: '1px solid #f0f0f0', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}
                bodyStyle={{ padding: '12px 14px' }}
            >
                {/* Fungsi + Aksi */}
                <Row justify="space-between" align="middle" wrap={false}>
                    <Col flex="1" style={{ minWidth: 0, paddingRight: 8 }}>
                        <Text strong style={{ fontSize: 13, display: 'block' }}>{record.fungsi_nama}</Text>
                        <Text type="secondary" style={{ fontSize: 11 }}>
                            <CalendarOutlined style={{ marginRight: 4 }} />
                            {record.mulai_dari} — {record.sampai_dengan}
                        </Text>
                    </Col>
                    <Col>
                        <Space size={6}>
                            {record.deleted_at ? (
                                <Button size="small" type="primary" ghost icon={<FormOutlined />} style={{ borderRadius: 6 }} disabled />
                            ) : (
                                <Link to={configClass.pageUrl.form + record.id}>
                                    <Button size="small" type="primary" ghost icon={<FormOutlined />} style={{ borderRadius: 6 }} />
                                </Link>
                            )}
                            {!record.deleted_at ? (
                                <Button size="small" danger ghost icon={<CloseSquareOutlined />} style={{ borderRadius: 6 }} onClick={() => this.showDeleteConfirm(record.id)} />
                            ) : (
                                <Button size="small" ghost icon={<UndoOutlined />} style={{ borderRadius: 6, borderColor: '#52c41a', color: '#52c41a' }} onClick={() => this.showRestoreConfirm(record.id)} />
                            )}
                        </Space>
                    </Col>
                </Row>
                {record.deleted_at && (
                    <Tag style={{ marginTop: 6, borderRadius: 20, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>Tidak Aktif</Tag>
                )}

                <Divider style={{ margin: '10px 0' }} />

                {/* Persentase 2-kolom */}
                <Row gutter={[8, 8]}>
                    {PERSEN_GROUPS.map((g) => (
                        <Col xs={12} key={g.key}>
                            <div style={{
                                borderRadius: 8,
                                border: `1px solid ${g.color}30`,
                                background: `${g.color}0a`,
                                padding: '7px 9px',
                            }}>
                                <Tag
                                    color={g.color}
                                    style={{ fontSize: 10, lineHeight: '16px', marginBottom: 5, display: 'block', textAlign: 'center' }}
                                >
                                    {g.label}
                                </Tag>
                                <Row>
                                    <Col span={12} style={{ textAlign: 'center' }}>
                                        <Text style={{ fontSize: 9, display: 'block', color: '#8c8c8c' }}>Pokok</Text>
                                        <Text strong style={{ fontSize: 12, color: g.color }}>{pct(record[g.pokok])}</Text>
                                    </Col>
                                    <Col span={12} style={{ textAlign: 'center' }}>
                                        <Text style={{ fontSize: 9, display: 'block', color: '#8c8c8c' }}>Denda</Text>
                                        <Text strong style={{ fontSize: 12, color: g.color }}>{pct(record[g.denda])}</Text>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    ))}
                </Row>

                <Divider style={{ margin: '10px 0' }} />

                {/* Kondisi */}
                <Row gutter={[4, 4]}>
                    {KONDISI_FIELDS.map((f) => (
                        <Col key={f.name}>
                            <Tag
                                color={record[f.name] ? f.color : 'default'}
                                style={{ fontSize: 11, borderRadius: 4, opacity: record[f.name] ? 1 : 0.35 }}
                            >
                                {record[f.name]
                                    ? <CheckCircleFilled style={{ marginRight: 3 }} />
                                    : <CloseCircleFilled style={{ marginRight: 3 }} />
                                }
                                {f.label}
                            </Tag>
                        </Col>
                    ))}
                </Row>
            </Card>
        );
    }

    render() {
        const { isMobile, loadingData, dataSource, pagination, errMsg } = this.state;

        return (
            <div>
                <Helmet>
                    <title>{configClass.title + ' | ' + config.get_site_info().name}</title>
                    <style>{`
                        .row-nonaktif > td { opacity: 0.55; background: #fff9f9 !important; }
                        .row-nonaktif:hover > td { opacity: 0.75 !important; background: #fff1f0 !important; }
                    `}</style>
                </Helmet>


                {/* ── Header ─────────────────────────────────────── */}
                <div style={{
                    marginBottom: 12,
                    borderRadius: 10,
                    overflow: 'hidden',
                    background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
                    padding: '16px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 10,
                    boxShadow: '0 4px 16px rgba(15,40,71,0.18)',
                }}>
                    <div>
                        <div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
                            <PercentageOutlined style={{ marginRight: 8 }} />
                            {configClass.title}
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                            {pagination.total != null ? `Total ${pagination.total} data diskon` : 'Memuat...'}
                            {loadingData && ' · Memuat...'}
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <Input.Search
                            size="middle"
                            placeholder="Cari diskon..."
                            allowClear
                            onSearch={(val) => this.setState({ searchText: val }, () => this.getData())}
                            style={{ width: isMobile ? '100%' : 200, borderRadius: 8 }}
                        />
                        <Button
                            icon={<RedoOutlined />}
                            onClick={() => this.getData()}
                            style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
                        >
                            {!isMobile && 'Refresh'}
                        </Button>
                        <Link to={configClass.pageUrl.form}>
                            <Button type="primary" icon={<PlusOutlined />}
                                style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
                            >
                                {isMobile ? 'Tambah' : 'Tambah Diskon'}
                            </Button>
                        </Link>
                    </div>
                </div>

                {/* ── Alert Error ─────────────────────────────────── */}
                <ErrorAlertModal
                    visible={errMsg !== ''}
                    title="Gagal memuat data"
                    error={errMsg}
                    onClose={() => this.setState({ errMsg: '' })}
                />

                {/* ── Mobile: card list ─────────────────────────── */}
                {isMobile ? (
                    loadingData ? (
                        <div style={{ textAlign: 'center', padding: 40 }}>
                            <img src={process.env.PUBLIC_URL + '/loading_crop.gif'} height="40" alt="loading" />
                        </div>
                    ) : dataSource.length === 0 ? (
                        <Card style={{ borderRadius: 8, textAlign: 'center' }} bodyStyle={{ padding: 40 }}>
                            <Text type="secondary">Tidak ada data diskon</Text>
                        </Card>
                    ) : (
                        dataSource.map((r) => this.renderMobileCard(r))
                    )
                ) : (
                    /* ── Desktop: table ─────────────────────────── */
                    <Card style={{ borderRadius: 8, border: '1px solid #f0f0f0' }} bodyStyle={{ padding: 0 }}>
                        <Table
                            bordered
                            columns={this.getTableColumns()}
                            dataSource={dataSource}
                            loading={loadingData}
                            rowKey="id"
                            scroll={{ x: 'max-content', y: 500 }}
                            size="middle"
                            rowClassName={(row) => row.deleted_at ? 'row-nonaktif' : ''}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </Card>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
    mapStateToProps,
    { initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(DataDiskon);
